import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import Layout from "../../components/Layout/Layout";
import SearchSelectComponent, { SelectItemsProps } from "../../components/SearchSelectComponent";
import { AssistanceService } from "../../services/AssistanceService";
import Toast from "../../helpers/Toast";
import PageTitle from "../../components/Layout/PageTitle";
import { GetDocNumberDTO } from "../../models/Assistance/GetDocNumberDTO";
import InputComponent from "../../components/InputComponent";
import { SearchBySupplierNameDTO } from "../../models/Supplier/SearchBySupplierNameDTO";
import { SupplierService } from "../../services/SupplierService";
import { ClientQuotationService } from "../../services/ClientQuotationService";
import { Parameter } from "../../models/Parameter";
import { ClientQuotationDTO } from "../../models/Quotation/ClientQuotationDTO";
import { CreateSupplierQuotationDTO } from "../../models/Quotation/CreateSupplierQuotationDTO";
import { SupplierQuotationService } from "../../services/SupplierQuotationService";

export default function CreateSupplierQuotation() {
  const intl = useIntl();
  const navigate = useNavigate();
  const assistanceService = new AssistanceService();
  const supplierService = new SupplierService();
  const clientQuotationService = new ClientQuotationService();
  const supplierQuotationService = new SupplierQuotationService();
  const [loading, setLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState<SelectItemsProps | null>(null);
  const [selectedAssistance, setSelectedAssistance] = useState<SelectItemsProps | null>(null);
  const [selectedClientQuotation, setSelectedClientQuotation] = useState<SelectItemsProps | null>(null);
  const [inputSupplier, setInputSupplier] = useState<string>("");
  const [inputAssistance, setInputAssistance] = useState<string>("");
  const [inputClientQuotation, setInputClientQuotation] = useState<string>("");
  const [inputNotes, setInputNotes] = useState<string>("");
  const [inputDescription, setInputDescription] = useState<string>("");
  

  const handleSubmit = async () => {


    if (!selectedSupplier) {
      Toast.Show("error", intl.formatMessage({id: "Screens.SupplierQuotation.Supplier.Missing"}));
      return;
    }

    if(!inputDescription) {
      Toast.Show("error", intl.formatMessage({id: "Screens.SupplierQuotation.Description.Missing"}));
      return;
    }

    if (inputDescription.length > 500) {
        Toast.Show("error", intl.formatMessage({id: "Screens.SupplierQuotation.Description.MaxLenght"}));
        return;
      }

    setLoading(true);

    const supplierQuotationDTO: CreateSupplierQuotationDTO = {
        supplierId: Number(inputSupplier),
        assistanceId: inputAssistance ? Number(inputAssistance) : undefined,
        clientQuotationId: inputClientQuotation ? Number(inputClientQuotation) : undefined,
        description: inputDescription,
        notes: inputNotes,
        };

    const response = await supplierQuotationService.Create(supplierQuotationDTO);
    if (response.success === false || response.obj === null) {
      Toast.Show("error", response.message);
      setLoading(false);
      return;
    }
    
    Toast.Show("success", intl.formatMessage({id: "Screens.SupplierQuotation.Parts.Info.Success",}));
    
    setLoading(false);

    navigate("/supplierQuotations"); 
  };

  const searchAssistance = async (
    docNumber: number
    ): Promise<SelectItemsProps[]> => {
        const searchParams: GetDocNumberDTO = { docNumber };
            const response = await assistanceService.GetAssistanceIdByDoc(searchParams);
    
            if (response.success === false || response.obj === null) {
                Toast.Show("error", response.message);
            }
    
            const list: SelectItemsProps[] = [];
            response.obj?.forEach((element) => {
                const item: SelectItemsProps = {
                    value: element.id,
                    label: element.docType + " " + element.serie.toString() + " " + element.number.toString(),
                };
                list.push(item);
            });
            return list;
      };

  const searchSupplier = async (
    name: string
    ): Promise<SelectItemsProps[]> => {
        const searchParams: SearchBySupplierNameDTO = { name };

        const response = await supplierService.SearchByName(searchParams);

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
        }

        const list: SelectItemsProps[] = [];
        response.obj?.forEach((element) => {
            const item: SelectItemsProps = {
                value: element.id.toString(),
                label: element.name,
            };
            list.push(item);
        });
        
        return list;
  };

  const searchClientQuotation = async (
    id: number
    ) => {
    
    setLoading(true);

    //Vamos obter os dados
    var parameters: Parameter[] = [];
        parameters.push(new Parameter("id", id));

    var response = await clientQuotationService.GetAll(
        parameters, parameters, 1, 5);

    if (response.success === false || response === null) {
            Toast.Show("error", response.message);
            setLoading(false); 
            return [];
        }

        const list: SelectItemsProps[] = [];
        if (response.items) {
            response.items.forEach((element: ClientQuotationDTO) => {
                const item: SelectItemsProps = {
                    value: element.id.toString(),
                    label: element.id.toString(),
                };
                list.push(item);
            });
        }

        setLoading(false); 
        return list;    
    };


  return (
    <Layout>
      <div className="pageContainer">
      <div className="pageHeader">
          <PageTitle title={"Novo Pedido de Cotação"} allowGoBack={true} />
        </div>
        <div className="pageBody">
          <label style={{ margin: "0px", padding: "13px" }}>
            <b>{intl.formatMessage({id: "Screens.SupplierQuotation.Info"})}</b>
          </label>
            <Row style={{ margin: "0px", padding: "8px" }}>
                    <SearchSelectComponent
                        xl={2}
                        lg={3}
                        md={4}
                        sm={12}
                        xs={12}
                        label={intl.formatMessage({
                            id: "Screens.Quotation.Info.Supplier",
                        })}
                        loadOptions={searchSupplier}
                        onChange={(e: SelectItemsProps) => {
                            setSelectedSupplier(e);
                            setInputSupplier(e.value);
                        }}
                        value={selectedSupplier}
                        style={{ width: "100%" }}
                    />
                    <SearchSelectComponent
                        xl={2}
                        lg={3}
                        md={4}
                        sm={12}
                        xs={12}
                        label={intl.formatMessage({
                            id: "Screens.Quotation.Info.Assistance",
                        })}
                        loadOptions={(value: string) => searchAssistance(Number(value))}
                        onChange={(e: SelectItemsProps) => {
                            setSelectedAssistance(e);
                            setInputAssistance(e.value);
                        }}
                        value={selectedAssistance}
                        style={{ width: "100%" }}
                    />
                    <SearchSelectComponent
                        xl={2}
                        lg={3}
                        md={4}
                        sm={12}
                        xs={12}
                        label={intl.formatMessage({
                            id: "Screens.Quotation.Info.ClientQuotation",
                        })}
                        loadOptions={(value: string) => searchClientQuotation(Number(value))}
                        onChange={(e: SelectItemsProps) => {
                            setSelectedClientQuotation(e);
                            setInputClientQuotation(e.value);
                        }}
                        value={selectedClientQuotation}
                        style={{ width: "100%" }}
                    />
            </Row>
            <Row style={{ margin: "0px", padding: "8px" }}>
                <Col>
                    <InputComponent
                        xl={5}
                        lg={5}
                        md={5}
                        sm={10}
                        xs={10}
                        style={{ width: "119%" }}
                        type={"textArea"}
                        value={inputDescription}
                        label={intl.formatMessage({ id: "Screens.Quotation.Info.Description" })}
                        readOnly={false}
                        onChange={(t: string) => setInputDescription(t)}
                        placeholder={intl.formatMessage({ id: "Screens.Quotation.Info.MaxLength" })}
                        />
                </Col>
            </Row> 
            <Row style={{ margin: "0px", padding: "8px" }}>
                <Col>
                    <InputComponent
                        xl={5}
                        lg={5}
                        md={5}
                        sm={10}
                        xs={10}
                        style={{ width: "119%" }}
                        type={"text"}
                        value={inputNotes}
                        label={intl.formatMessage({ id: "Screens.Quotation.Info.Notes" })}
                        readOnly={false}
                        onChange={(t: string) => setInputNotes(t)}
                    />
                </Col>
            </Row>
            <Row style={{ margin: "0px", padding: "8px" }}>
              <Col>
                <ButtonComponent
                  disabled={loading}
                  loading={loading}
                  text={intl.formatMessage({
                      id: "Screens.ClientQuotation.Button.Create",
                  })}
                  onClick={handleSubmit}
                />
              </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
}
